import styled from 'styled-components';
import { StyledRotatingTextProps } from './RotatingText.types';

export const StyledRotatingText = styled.div<StyledRotatingTextProps>`
  overflow: hidden;
  display: grid;

  .rotating-text__text {
    grid-column: 1;
    grid-row: 1;
  }

  .rotating-text__text {
    transition: all
      ${(props: StyledRotatingTextProps) => props.transitionDuration / 1000}s
      ${(props: StyledRotatingTextProps) => props.transitionEasing};
  }

  ${(props) => props.customStyle}
`;
